
import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import * as React from 'react';

import { featureFlagStates } from './constants';
import { FeatureCarouselAnimatedCard } from './feature-carousel.animated-card';

const ANIMATION_INTERVAL = 3000; // 3 seconds

export function FeatureCarousel() {
  const [items, setItems] = useState(featureFlagStates);

  useEffect(() => {
    const rotate = () => {
      setItems((prevItems) => {
        const newItems = [...prevItems];
        const firstItem = newItems.shift();
        if (firstItem) {
          newItems.push(firstItem);
        }
        return newItems;
      });
    };

    let interval: NodeJS.Timeout;

    const initialTimeout = setTimeout(() => {
      rotate();
      interval = setInterval(rotate, ANIMATION_INTERVAL);
    }, 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(initialTimeout);
    };
  }, []);

  return (
    <div className="w-full max-w-3xl mx-auto h-[402px] lg:min-h-[600px] overflow-hidden">
      <div className="flex flex-col fade-container px-4 @container">
        <AnimatePresence mode="sync">
          {items.map((flag, index) => (
            <FeatureCarouselAnimatedCard
              key={flag.featureFlagEnvironmentStateId}
              flag={flag}
              index={index}
            />
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}
